// extracted by mini-css-extract-plugin
module.exports = {"list":"_0fce717cdb--list--_Rz6q","item":"_0fce717cdb--item--loU3s"};